export const USER_REQUEST = 'USER_REQUEST';
export const USER_REQUEST_BY_ID = 'USER_REQUEST_BY_ID';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_REQUEST_BY_ID_SUCCESS = 'USER_REQUEST_BY_ID_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const USER_EMPTY = 'USER_EMPTY';
export const USER_ADD = 'USER_ADD';
export const USER_DELETE = 'USER_DELETE';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_SEND_COI_REMINDER = 'USER_SEND_COI_REMINDER';
export const USER_UPDATE_COI = 'USER_UPDATE_COI';
export const USER_CLEAR_DATA = 'USER_CLEAR_DATA';
